import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./components/Home";
import { Impressum } from "./components/Impressum";
import { AGB } from "./components/AGB";
import { Datenschutz } from "./components/Datenschutz";
import { ScrollToTop } from "./components/ScrollToTop";
import { UserDashboard } from "./components/UserDashboard";
import { UserPortal } from "./components/UserPortal";
import { CompanyDashboard } from "./components/CompanyDashboard";
import { AdminPanel } from "./components/AdminPanel";
import { Kaufen } from "./components/Kaufen";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Team } from "./components/Team";
import { Partner } from "./components/Partner";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LanguageProvider>
          <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/team" element={<Team />} />
            <Route path="/partner" element={<Partner />} />
            <Route
              path="/portal"
              element={
                <ProtectedRoute>
                  <UserPortal />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <UserDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/kaufen"
              element={
                <ProtectedRoute>
                  <Kaufen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/company-dashboard"
              element={
                <ProtectedRoute>
                  <CompanyDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
